import TreatmentGroupActions from './TreatmentGroupActions';

export default TreatmentGroupActions;
